export default __webpack_public_path__ + "static/media/facebook-logo.7515ca3e.svg";